import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { InboundComposeFormValues } from '../../types';

interface Props {
  values: InboundComposeFormValues;
  setValues: (patch: Partial<InboundComposeFormValues>) => void;
  /** Autofocus the name input the first time the user lands on this step. */
  autoFocusName?: boolean;
}

export function StepBasics({ values, setValues, autoFocusName }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Basics</CardTitle>
        <CardDescription>
          Name the campaign and set how aggressively unanswered calls retry.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="space-y-2 md:col-span-2">
          <Label htmlFor="name">
            Campaign name
            <span className="ml-1 text-destructive">*</span>
          </Label>
          <Input
            id="name"
            value={values.campaignName}
            onChange={(e) => setValues({ campaignName: e.target.value })}
            autoFocus={autoFocusName}
            placeholder="e.g. Support hotline"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="retries">Retries</Label>
          <Input
            id="retries"
            inputMode="numeric"
            value={String(values.retries)}
            onChange={(e) =>
              setValues({
                retries: Number(e.target.value.replace(/\D/g, '')) || 0,
              })
            }
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="retry-interval">Retry interval (minutes)</Label>
          <Input
            id="retry-interval"
            inputMode="numeric"
            value={String(values.retryInterval)}
            onChange={(e) =>
              setValues({
                retryInterval:
                  Number(e.target.value.replace(/\D/g, '')) || 0,
              })
            }
          />
        </div>
      </CardContent>
    </Card>
  );
}
